const colorCache = new Map();

function sortColors() {
  async function sortColorContainer(container) {
    if (!container) return;
    
    const colorPickers = container.querySelectorAll(".color-picker:not(.white)");
    if (!colorPickers.length) return;

    try {
      const sortedColors = await Promise.all(
        Array.from(colorPickers).map(async (colorPicker) => {
          const renderElement = colorPicker.querySelector(".color-picker__render");
          if (!renderElement) return { colorPicker, color: [0, 0, 0] };

          const bgImage = window.getComputedStyle(renderElement).backgroundImage;
          const imageUrl = bgImage.replace(/url\(['"]?(.*?)['"]?\)/i, "$1");
          
          if (colorCache.has(imageUrl)) {
            return { colorPicker, color: colorCache.get(imageUrl) };
          }

          const color = await getDominantColor(imageUrl);
          colorCache.set(imageUrl, color);
          return { colorPicker, color };
        })
      );

      sortedColors.sort((a, b) => compareColors(b.color, a.color));
      container.innerHTML = "";
      sortedColors.forEach(({ colorPicker }) => container.appendChild(colorPicker));
      container.classList.remove('hidden');
    } catch (error) {
      console.error('Error sorting colors:', error);
    }
  }

  async function getDominantColor(imageUrl) {
    return new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      
      img.onload = function() {
        try {
          const color = getAverageColor(img);
          resolve(color);
        } catch (error) {
          console.error('Error getting dominant color:', error);
          resolve([0, 0, 0]);
        }
      };

      img.onerror = function() {
        console.error('Error loading image:', imageUrl);
        resolve([0, 0, 0]);
      };

      img.src = imageUrl;
    });
  }

  function getAverageColor(img) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    canvas.width = 1;
    canvas.height = 1;
    context.drawImage(img, 0, 0, 1, 1);
    const pixel = context.getImageData(0, 0, 1, 1).data;
    return [pixel[0], pixel[1], pixel[2]];
  }

  function compareColors(colorA, colorB) {
    const lumaA = calculateLuma(colorA);
    const lumaB = calculateLuma(colorB);
    return lumaA - lumaB;
  }

  function calculateLuma(color) {
    return 0.299 * color[0] + 0.587 * color[1] + 0.114 * color[2];
  }

  const mainContainer = document.querySelector("div.color_picker-colors.active")?.querySelector(".color_picker-colors-container") || 
                       document.querySelector(".color_picker-colors-container");
  sortColorContainer(mainContainer);

  const seasonalContainer = document.querySelector(".seasonal-colors-container");
  if (seasonalContainer) {
    sortColorContainer(seasonalContainer).then(() => {
      if (seasonalContainer.innerHTML.trim() !== '' && 
          document.querySelector('.product-pack__content')?.classList.contains('hidden')) {
        document.querySelector('.seasonal-color_picker')?.classList.remove('hidden');
      }
    });
  }

  document.querySelectorAll('[class*="color-group-"] .color_picker-colors-container').forEach(container => {
    if (container.innerHTML.trim() !== '') {
      sortColorContainer(container);
    }
  });
}
